import AltInstance from 'common-ui/src/alt/AltInstance';

class MfaDropdownActions {
    constructor() {
        this.generateActions('selectDropdown', 'clearGroup');
    }
}
export default AltInstance.createActions(MfaDropdownActions);
